/**
 * Componente para mostrar el progreso de rangos en el carrito
 */

if ( typeof RangoProgress !== 'function' ) {

	class RangoProgress extends HTMLElement {
		
		constructor() {
			super();
			this.init();
		}

		init() {
			// Escuchar actualizaciones del carrito
			document.addEventListener('cart-updated', () => {
				this.updateProgress();
			});
			
			document.addEventListener('add-to-cart', () => {
				this.updateProgress();
			});
			
			// Actualizar al cargar
			this.updateProgress();
		}

		async updateProgress() {
			if (typeof window.RangosSystem === 'undefined') {
				return;
			}
			
			await window.RangosSystem.loadCart();
			const progreso = window.RangosSystem.obtenerProgreso();
			
			// Mostrar u ocultar el contenedor
			if (!progreso.rango2.desbloqueado || !progreso.rango3.desbloqueado) {
				this.style.display = 'block';
			} else {
				this.style.display = 'none';
				return;
			}
			
			// Actualizar mensaje de Rango 2
			const rango2El = this.querySelector('[data-rango-progress-r2]');
			if (rango2El && !progreso.rango2.desbloqueado) {
				const textoEl = rango2El.querySelector('.rango-progress__text');
				if (textoEl) {
					textoEl.textContent = `Te faltan ${progreso.rango2.faltante.toFixed(2)} € en Rango 1 para acceder al Rango 2.`;
				}
				rango2El.style.display = 'block';
			} else if (rango2El) {
				rango2El.style.display = 'none';
			}
			
			// Actualizar mensaje de Rango 3
			const rango3El = this.querySelector('[data-rango-progress-r3]');
			if (rango3El && !progreso.rango3.desbloqueado) {
				const textoEl = rango3El.querySelector('.rango-progress__text');
				if (textoEl) {
					textoEl.textContent = `Te faltan ${progreso.rango3.faltante.toFixed(2)} € en Rango 2 para acceder al Rango 3.`;
				}
				rango3El.style.display = 'block';
			} else if (rango3El) {
				rango3El.style.display = 'none';
			}
		}
	}

	if ( typeof customElements.get('rango-progress') == 'undefined' ) {
		customElements.define('rango-progress', RangoProgress);
	}

}

